export default {
    state: {
        sendPagesTab: 0,
        sendOperator: null,
        selectedPhonebook: null,
        sendAsGradual: false,
        gradualItem: {
            phones_gradual_time: 10,
            phones_gradual_type: 'min',
            phones_gradual_count: 500
        },
        blacklistCheck: {
            isFailed: false,
            alternateSend: 'sendToAll' // ['sendToAll', 'sendToWhite']
        }
    },
    getters: {
        sendTextPattern: state => {
            return state.sendPagesTab !== 1
                ? 'لغو11'
                : 'example.ex/any\nلغو11'
        },
        allowSendAsGradual: state => state.sendAsGradual
            && state.gradualItem.phones_gradual_count >= 500
            && !!state.gradualItem.phones_gradual_time
            && ['min', 'hour'].includes(state.gradualItem.phones_gradual_type),
        blacklistCheckFailed: state => state.blacklistCheck.isFailed,
        blacklistAlt: state => state.blacklistCheck.alternateSend,
        blacklistAlternateSends: () => [
            {
                value: 'sendToAll',
                text: 'ارسال پیامک به کلیه شماره‌ها',
                description: 'پیامک شما با شماره خبری ارسال میشود. و همه شماره ها پیامک شما را دریافت میکنند.',
                number: '5000439728165'
            },
            {
                value: 'sendToWhite',
                text: 'ارسال پیامک به شماره‌های آزاد (وایت لیست)',
                description: 'پیامک شما با شماره تبلیغاتی ارسال میشود. و فقط شماره های آزاد پیامک شما را دریافت خواهند کرد.\nهزینه پیامک های ارسال نشده به کیف پول شما بازگشت داده میشود.',
                number: '123450'
            },
        ]
    },
    actions: {
        SetSendTabs({commit}, tab) {
            commit('set_send_tabs', tab)
        },
        SetSendOperator({commit}, op) {
            commit('set_send_operator', op)
        },
        setSelectedPhonebook({commit}, tag) {
            commit('set_selected_phonebook', tag)
        },
        setSendAsGradual({commit}, input) {
            commit('set_send_as_gradual', input)
        },
        setGradualItem({commit}, item) {
            commit('set_gradual_item', item)
        },
        setBlacklistCheck({commit}, {isFailed, alt}) {
            commit('set_blacklist_check', {isFailed, alt})
        },
    },
    mutations: {
        set_send_tabs(state, tab) {
            state.sendPagesTab = tab
        },
        set_send_operator(state, op) {
            state.sendOperator = op
        },
        set_selected_phonebook(state, tag) {
            state.selectedPhonebook = tag
        },
        set_send_as_gradual(state, input) {
            state.sendAsGradual = input
        },
        set_gradual_item(state, item) {
            state.gradualItem = item
        },
        set_blacklist_check(state, {isFailed, alt}) {
            console.log('blacklist check: ', isFailed, alt)

            state.blacklistCheck = {
                isFailed: isFailed ?? state.blacklistCheck.isFailed,
                alternateSend: alt ?? state.blacklistCheck.alternateSend
            }
        },
    },
    namespaced: true,
};